import { HeadProps } from "gatsby"
import React from "react"

import DatoSeo from "../../dato-components/dato-seo"
import { ArticleJsonMd } from "../../dato-components/dato-seo/article-json-md"
import BlogPostContent from "../../page-components/blog/post-content"
import SuggestionsSection from "../../page-components/blog/post-footer/suggestions-section"
import { BlogPostPageContext } from "../../page-components/blog/types"
import { generateBlogFaqSchema } from "../../page-components/blog/utils/faq-extractor"
import ArticleHeader from "../../shared-components/article-heading"
import Layout from "../../shared-components/layout"
import { JsonContentMarkup } from "../../shared-components/seo/json-content-markup"

type Props = {
  pageContext: BlogPostPageContext
}

const PostTemplate = ({
  pageContext: {
    datoUpdatedAt: updatedAt,
    createdAt,
    body,
    suggestedPosts,
    ...rest
  },
}: Props) => (
  <Layout>
    <BlogPostContent
      articleHeader={
        <ArticleHeader {...rest} updatedAt={updatedAt} createdAt={createdAt} />
      }
      body={body}
    />
    <SuggestionsSection suggestedPosts={suggestedPosts} />
  </Layout>
)

export default PostTemplate

export const Head = ({
  pageContext: {
    seoMetaTags,
    title,
    coverImage,
    author,
    datoUpdatedAt: updatedAt,
    nonCrawlable,
    body,
  },
  location: { pathname },
}: HeadProps<object, BlogPostPageContext>) => {
  const faqSchema = generateBlogFaqSchema(body)

  return (
    <>
      <DatoSeo
        seoMetaTags={seoMetaTags}
        pathname={pathname}
        nonCrawlable={nonCrawlable}
      />
      <ArticleJsonMd
        headline={title}
        image={coverImage.url}
        datePublished={updatedAt}
        authorNames={[author]}
      />
      {faqSchema && <JsonContentMarkup content={faqSchema} />}
    </>
  )
}
